"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrincipalInfo = exports.ParticipantInfo = exports.ParticipantUserInfo = exports.HostInfo = exports.ConfigurationItem = exports.TokenInfo = void 0;

var TokenInfo =
/** @class */
function () {
  function TokenInfo() {}

  return TokenInfo;
}();

exports.TokenInfo = TokenInfo;

var ConfigurationItem =
/** @class */
function () {
  function ConfigurationItem() {}

  return ConfigurationItem;
}();

exports.ConfigurationItem = ConfigurationItem;

var HostInfo =
/** @class */
function () {
  function HostInfo() {}

  return HostInfo;
}();

exports.HostInfo = HostInfo;
/**
 * Non session specific participant info.
 *
 * @export
 * @class ParticipantUserInfo
 */

var ParticipantUserInfo =
/** @class */
function () {
  function ParticipantUserInfo() {
    /**
     * Requested theme of the addon UI.
     * Default is dark theme.
     *
     * @type {('dark' | 'light')}
     * @memberof InitMessage
     */
    this.theme = 'dark';
  }

  return ParticipantUserInfo;
}();

exports.ParticipantUserInfo = ParticipantUserInfo;

var ParticipantInfo =
/** @class */
function (_super) {
  __extends(ParticipantInfo, _super);

  function ParticipantInfo() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return ParticipantInfo;
}(ParticipantUserInfo);

exports.ParticipantInfo = ParticipantInfo;

var PrincipalInfo =
/** @class */
function (_super) {
  __extends(PrincipalInfo, _super);

  function PrincipalInfo() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  return PrincipalInfo;
}(ParticipantInfo);

exports.PrincipalInfo = PrincipalInfo;